module.exports = __webpack_public_path__ + "img/slack.cd0c7894.png";